import { cn } from "@fronterahealth/frontera-ui-components/lib/utils";
import { Avatar, AvatarFallback } from "@fronterahealth/frontera-ui-components/ui/avatar";
import { ItemMedia } from "@fronterahealth/frontera-ui-components/ui/item";

import { ReviewItemFieldsFragment } from "@api/graphql/types-and-hooks";
import { PersonAvatar } from "@components/QaReview/components/PersonAvatar";
import { getCommentAuthor } from "@components/QaReview/components/commentAuthor";
import { FALLBACK_ICON, getSuggestionIcon } from "@components/QaReview/components/suggestionIcon";

export const AuthorAvatar: React.FC<{ comment: ReviewItemFieldsFragment }> = ({ comment }) => {
  const author = getCommentAuthor(comment);

  if (author) {
    return (
      <ItemMedia>
        <PersonAvatar id={author.id} initials={author.initials} size="sm" />
      </ItemMedia>
    );
  }

  const category = comment.__typename === "ReportSuggestionType" ? comment.category : "";
  const { Icon, iconClassName } = getSuggestionIcon(category);
  const IconComponent = Icon ?? FALLBACK_ICON;

  return (
    <ItemMedia>
      <Avatar size="sm">
        <AvatarFallback className={cn("text-white", iconClassName)}>
          <IconComponent className="size-3" />
        </AvatarFallback>
      </Avatar>
    </ItemMedia>
  );
};
